import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IFaq } from "../../../Pages/Setting/ISetting";
import { IAPIResponse } from "../../interfaces/IAPIResponse";

export const ListFAQSlice = createSlice({
    name: "ListFAQSlice",
    initialState: {} as IReduxState<IFaq[]>,
    reducers: {
        listFAQ: (state) => {
            state.isLoading = true;
        },
        successlistFAQ: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failurelistFAQ: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearListFAQ: (state) => {
            state.data = {} as IAPIResponse<IFaq[]>;
        },
    },
});

export const { failurelistFAQ, listFAQ, successlistFAQ, clearListFAQ } =
    ListFAQSlice.actions;

export default ListFAQSlice.reducer;
